import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import Alert from '@/store/Alert'
import Configuration from '@/store/Configuration'
import HouseList from '@/store/HouseList'
import LeaseList from '@/store/LeaseList'
import Progress from '@/store/Progress'
import User from '@/store/User'
import Payments from '@/store/Payments'
import Tasks from '@/store/Tasks'
import Repairs from '@/store/Repairs'
import Issues from '@/store/Issues'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Alert,
    Configuration,
    HouseList,
    LeaseList,
    Tasks,
    Progress,
    User,
    Payments,
    Repairs,
    Issues,
  },
})
